import React from "react"
import Map from "../shared/about/Map"

const parameters = 'pb=!1m18!1m12!1m3!1d373.79249174335604!2d139.03532691715606!3d36.644035134385724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601e69394df6cc91%3A0xc5c96aefa15eec83!2sDo!5e0!3m2!1sja!2sjp!4v1747296437197!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>'

const AboutMap = () => {
  return <Map parameters={ parameters } />
}

export default AboutMap